export default "__VITE_ASSET__BIDZL2yR__"